import { render, staticRenderFns } from "./CarisInformation.vue?vue&type=template&id=04839b70&scoped=true"
import script from "./CarisInformation.vue?vue&type=script&lang=js"
export * from "./CarisInformation.vue?vue&type=script&lang=js"
import style0 from "./CarisInformation.vue?vue&type=style&index=0&id=04839b70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04839b70",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fcaris-information%2FCarisInformation.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports